import { render } from "./owl101112Page.vue?vue&type=template&id=77d0a644"
import script from "./owl101112Page.vue?vue&type=script&lang=js"
export * from "./owl101112Page.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__